import { classNameType } from "@/types/generalTypes";
import React from "react";

function DeleteBaasketIcon({ className }: classNameType) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 15 14"
      fill="none"
    >
      <g clipPath="url(#clip0_237_5708)">
        <path
          d="M1.3457 2.85132H13.8912"
          stroke="#686868"
          strokeWidth="0.855372"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.90147 0.570312H6.33535C6.1085 0.570312 5.89092 0.660434 5.73051 0.820845C5.5701 0.981256 5.47998 1.19883 5.47998 1.42568V2.8513H9.75684V1.42568C9.75684 1.19883 9.66674 0.981256 9.50633 0.820845C9.34592 0.660434 9.12831 0.570312 8.90147 0.570312Z"
          stroke="#686868"
          strokeWidth="0.855372"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5303 12.3288C11.5144 12.5431 11.4179 12.7435 11.2603 12.8895C11.1026 13.0355 10.8955 13.1164 10.6806 13.1158H4.55613C4.34125 13.1164 4.13411 13.0355 3.97646 12.8895C3.8188 12.7435 3.72233 12.5431 3.70646 12.3288L2.91382 2.85132H12.3229L11.5303 12.3288Z"
          stroke="#686868"
          strokeWidth="0.855372"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_237_5708">
          <rect
            width="13.686"
            height="13.686"
            fill="white"
            transform="translate(0.776855)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default DeleteBaasketIcon;
